import styles from './AdminMediaPlayerChrome.module.css'

export const adminMediaPlayerClassName = (...classes: Array<string | false | null | undefined>): string =>
  classes
    .filter(Boolean)
    .map((className) => styles[className as string] ?? className)
    .join(' ')

